import { envConfig } from '../../envConfig'

const webUrlBase = envConfig.url.API_URL

export const urlAddressSuggestions =`${webUrlBase}api/mobile/addresses/autocomplete`;